
import map_url from "@/assets/images/why-trackmate/map.png"
import AnimatedCar from "@/components/AnimatedMap/Car";
import DesktopMap from "@/components/AnimatedMap/DesktopMap";
import useResponsive from "@/hooks/useResponsive";
import { Box, CardMedia, SxProps, Theme } from "@mui/material";
import { useMemo } from "react";
import { animated, useSpring } from "react-spring";
import { desktopSizes } from "./mockData";
import { getDesktopOptions, getSize } from "./utils";
import AnimatedMobileMap from "./components/AnimatedMobileMap";

const Map = ({ sx }: { sx?: SxProps<Theme> }) => {
  const isMobile = useResponsive("down", "md");
  const isTablet = useResponsive("between", "md", "lg");
  const desktopSize = useMemo(
    () => {
      if (isMobile) {
        return desktopSizes.xs;
      };
      if (isTablet) {
        return desktopSizes.md;
      };
      return desktopSizes.lg;
    },
    [isMobile, isTablet]
  );
  const desktopOptions = useMemo(() => {
    const getWidth = getSize(desktopSizes.lg.width / desktopSize.width);
    const getHeight = getSize(desktopSizes.lg.height / desktopSize.height);
    return getDesktopOptions(getWidth, getHeight);
  }, [desktopSize]);
  const [mapStyles] = useSpring(() => (desktopOptions.map), []);
  const AnimatedMap = animated((props) => (
    <Box
      sx={{
        position: "absolute",
        width: desktopSize.width,
        height: desktopSize.height,
      }}
      {...props}
    >
      <CardMedia 
        component="img"
        image={map_url} 
        width="100%"
        height="100%"
      />
      <AnimatedCar options={desktopOptions.car} />
    </Box>
  ));

  return (
    <Box sx={{ 
      position: { xs: "absolute", md: "relative"},
      right: { xs: "-100px", md: "0px" },
      width: { xs: "440px", md: "604px", lg: "755px"},
      height: { xs: "280px", md: "387px", lg: "484px" },
      zIndex: "1",
      ...sx
     }}
    >
      <DesktopMap 
        sx={{
          width: "100%",
          height: "100%"
        }}
        leftSideSx={{
          width: { xs: "80px", md: "112px", lg: "140px" }
        }}
      >
        <AnimatedMap style={mapStyles} />
      </DesktopMap>
      {!isMobile ? (
        <Box
          sx={{
            position: "absolute",
            top: "54px",
            right: "-137px",
            width: { md: "176px", lg: "220px" },
            height: { md: "368px", lg: "461px" }
          }}
        >
          <AnimatedMobileMap />
        </Box>
      ) : null}
    </Box>
  );
};

export default Map;